import {
    SHOW_INCOMPLETE_TRADE_MODAL,
    HIDE_INCOMPLETE_TRADE_MODAL,
    SET_BYPASS_INCOMPLETE_TRADE_CHECK,
    CLEAR_BYPASS_INCOMPLETE_TRADE_CHECK
} from '../types/tradeInTypes';

export const showIncompleteTradeModal = () => ({
    type: SHOW_INCOMPLETE_TRADE_MODAL
});

export const hideIncompleteTradeModal = () => ({
    type: HIDE_INCOMPLETE_TRADE_MODAL
});

export const setBypassIncompleteTradeCheck = () => ({
    type: SET_BYPASS_INCOMPLETE_TRADE_CHECK
});

export const clearBypassIncompleteTradeCheck = () => ({
    type: CLEAR_BYPASS_INCOMPLETE_TRADE_CHECK
});
